import { render, staticRenderFns } from "./VHome.vue?vue&type=template&id=87f58836&"
import script from "./VHome.vue?vue&type=script&lang=js&"
export * from "./VHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports